var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2749 8.50001L9.72489 0.950012C9.32489 0.400012 8.67489 0.0750122 7.99989 0.0750122C7.29989 0.0750122 6.67489 0.400012 6.27489 0.950012L0.724891 8.50001C0.249891 9.15001 0.174891 10.025 0.549891 10.75C0.924891 11.475 1.64989 11.925 2.47489 11.925H13.5499C14.3749 11.925 15.0999 11.475 15.4749 10.75C15.8499 10.025 15.7499 9.15001 15.2749 8.50001ZM14.6749 10.35C14.4499 10.775 14.0249 11.05 13.5499 11.05H2.47489C1.97489 11.05 1.54989 10.8 1.34989 10.35C1.12489 9.92501 1.17489 9.42501 1.44989 9.02501L6.97489 1.47501C7.22489 1.15001 7.59989 0.950012 7.99989 0.950012C8.39989 0.950012 8.77489 1.15001 9.02489 1.47501L14.5499 9.02501C14.8499 9.42501 14.8999 9.90001 14.6749 10.35Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 7.49999C8.2498 7.49999 8.4498 7.29999 8.4498 7.04999V4.24999C8.4498 3.99999 8.2498 3.79999 7.9998 3.79999C7.7498 3.79999 7.5498 3.99999 7.5498 4.24999V7.07499C7.5498 7.29999 7.7498 7.49999 7.9998 7.49999Z",
    fill: "#FF9900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9999 8.32501C7.5999 8.32501 7.2749 8.65001 7.2749 9.05001C7.2749 9.45001 7.5999 9.77501 7.9999 9.77501C8.3999 9.77501 8.7249 9.45001 8.7249 9.05001C8.7249 8.65001 8.3999 8.32501 7.9999 8.32501Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ad5cc01b1367219f4a79704e9b5daf9a.svg";
export { ForwardRef as ReactComponent };